import create from 'zustand';

interface AiChatMinimizeState {
  isMinimized: boolean;
  setMinimized: (minimized: boolean) => void;
}

export const useAiChatMinimizeStore = create<AiChatMinimizeState>((set) => ({
  isMinimized: false,
  setMinimized: (minimized: boolean) => set({ isMinimized: minimized }),
}));
